import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useDefectRepairPictureV1ControllerGetByRepair } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetRepairPicturesData = (repairId?: string) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityScan);

  const { data, error, isLoading } =
    useDefectRepairPictureV1ControllerGetByRepair({
      queryParams: {
        repairId: repairId ?? '',
      },
      headers: restHeaders,
    });

  return {
    data,
    isLoading,
    error,
  };
};
